<template>
  <div class="preorder-redirect-container">
    <div class="loading-content">
      <VueIcon iconName="IconBasket" class="cart-icon" width="64" height="64" />
      <VueText sizeLevel="4" weightLevel="2">Yönlendiriliyor...</VueText>
      <VueText sizeLevel="6" weightLevel="1">Ön Sipariş sayfasına yönlendiriliyorsunuz</VueText>
    </div>
  </div>
</template>

<script>
import VueText from '@/components/shared/VueText/VueText.vue';
import VueIcon from '@/components/shared/VueIcon/VueIcon.vue';
import gtmUtils from '@/mixins/gtmUtils.js';
import preOrderUtils from '@/mixins/preOrderUtils.js';

export default {
  name: 'PreOrderRedirect',
  components: {
    VueText,
    VueIcon,
  },
  mixins: [gtmUtils, preOrderUtils],
  mounted() {
    // Get source from query parameter, default to 'redirect_link'
    const src = this.$route.query.src || 'redirect_link';
    const location = src === 'redirect_link' ? 'redirect_link' : `redirect_link_${src}`;
    this.handlePreOrderRedirect(location);
  },
};
</script>

<style lang="scss" scoped>
.preorder-redirect-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
  text-align: center;

  .loading-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;

    .cart-icon {
      width: 64px;
      height: 64px;
    }
  }
}
</style>
